import React, { useEffect, useState, useMemo } from "react"
import {
  Badge,
  Container,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Modal,
  Row,
  Col,
  Card,
  CardBody,
  Table,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import { Editor } from "@tinymce/tinymce-react"
import staffDocuments from "../../assets/images/staffDocuments.jpg"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import "../../assets/css/Sales/Sales.css"
import "../../assets/css/Sales/Contract.css"
import Loader from "pages/Separate/Loader"
import moment from "moment"
import configure from "configure"
import Select from "react-select"
import Swal from "sweetalert2"
import secureLocalStorage from "react-secure-storage"
import NewPagination from "components/Common/Newpagination"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import CopyToClipboard from "react-copy-to-clipboard"
import axios from "axios"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"

/* ------------------------------------------------------------------ */
/* --------------------------  TableContainer  ---------------------- */
/* ------------------------------------------------------------------ */
function TableContainer({
  columns,
  data,
  setLoading,
  setDatas,
  row,
  setRow,
  editDocID,
  editDoc,
  requirementType,
  setRequirementType,
  description,
  setDescription,
  staffIdp,
  fetchData,
  setLetterTemplateValue,
  letterTemplateValue,
  setLetterTypeOptions,
  letterType,
  letterTemplateOptions,
  setLetterTemplateOptions,
}) {
  const [fixedContent, setFixedContent] = useState(false)
  const [editorContent, setEditorContent] = useState(description || "")
  const [modal_large, setmodal_large] = useState(false)
  const navigate = useNavigate()

  /* ---------- scroll-fixed buttons ---------- */
  document.addEventListener("scroll", () => {
    setFixedContent(window.scrollY > 165)
  })

  const handleEditorChange = content => setEditorContent(content)

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable({ columns, data }, useGlobalFilter, usePagination)
  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])

  const colourStyles = {
    menuList: s => ({ ...s, background: "white" }),
    menu: b => ({ ...b, zIndex: 1200 }),
  }

  const [name_modal, setNameModal] = useState(false)
  const [title, setTitle] = useState("")

  const info = [
    {
      title: "Document Type",
      mean: "<p><strong>Meaning :</strong> The type of letter being generated (e.g., Appointment, Experience, Salary Increment).</p>",
      purpose:
        "<p><strong>Purpose :</strong> To categorize the generated document.</p>",
    },
    // add more if needed
  ]

  /* ---------- fetch letter-type options ---------- */
  const fetchLetterTypes = async () => {
    const res = await fetchNodeData(
      setLoading,
      `LetterTypes`,
      secureLocalStorage.getItem("auth_token")
    )
    if (res?.status) {
      const fmt = res.data.map(x => ({ value: x.id, label: x.LetterName }))
      setLetterTypeOptions(fmt)
    } else setLetterTypeOptions([])
  }
  useEffect(() => {
    fetchLetterTypes()
  }, [])

  /* ---------- fetch template options for selected type ---------- */
  const fetchLetterTemplateOptions = async data => {
    const res = await fetchNodeData(
      setLoading,
      `staffTemplate/Options/${data?.value}`,
      secureLocalStorage.getItem("auth_token")
    )
    if (res?.data?.success || res?.success) {
      const fmt = res.data.map(x => ({
        value: x.id,
        label: x.name,
        template: x.description,
      }))
      setLetterTemplateOptions(fmt)
    }
  }

  /* ---------- keep editor in sync with description prop ---------- */
  useEffect(() => setEditorContent(description || ""), [description])

  /* ---------- CREATE NEW LETTER ---------- */
  const handleSubmit = async e => {
    e.preventDefault()
    if (!requirementType || !letterTemplateValue) {
      Swal.fire({
        icon: "warning",
        text: "Please select Document Type & Template",
      })
      return
    }
    const fd = new FormData()
    fd.append("staff_id", staffIdp)
    fd.append("letterType", requirementType.label)
    fd.append("letterTemplate", letterTemplateValue.label)
    fd.append("template_format", editorContent)

    setLoading(true)
    const res = await FetchNodePostData(
      setLoading,
      "generateStaffLetter",
      secureLocalStorage.getItem("auth_token"),
      fd
    )
    if (res) {
      Swal.fire({ icon: "success", text: "Document created!" }).then(() => {
        setRequirementType(null)
        setLetterTemplateValue(null)
        setDescription("")
        fetchData()
        setRow(1)
      })
    }
  }

  /* ---------- EDIT EXISTING LETTER ---------- */
  const handleEditDoc = async e => {
    e.preventDefault()
    if (!requirementType || !letterTemplateValue) {
      Swal.fire({
        icon: "warning",
        text: "Please select Document Type & Template",
      })
      return
    }
    const fd = new FormData()
    fd.append("staff_id", staffIdp)
    fd.append("letter_id", editDocID)
    fd.append("requirement_type", requirementType.label)
    fd.append("letterTemplate", letterTemplateValue.label)
    fd.append("template_format", editorContent)

    setLoading(true)
    const res = await FetchNodePostData(
      setLoading,
      "generateStaffLetter/edit",
      secureLocalStorage.getItem("auth_token"),
      fd
    )
    if (res) {
      Swal.fire({ icon: "success", text: "Document updated!" }).then(() => {
        setRequirementType(null)
        setLetterTemplateValue(null)
        setDescription("")
        fetchData()
        setRow(1)
      })
    }
  }

  /* ------------------------------------------------------------------ */
  /* ---------------------------  UI  --------------------------------- */
  /* ------------------------------------------------------------------ */
  return (
    <div>
      {/* ---------- LIST VIEW ---------- */}
      {row === 1 && (
        <div>
          <div
            className={`flex-column fixed-buttons ${
              fixedContent ? "d-flex" : "d-none"
            }`}
          >
            <button
              className="btn btn-purple fix-btn"
              type="button"
              onClick={() => setRow(2)}
            >
              <i className="fas fa-plus me-2 icon-size"></i>
              <span>Generate</span>
            </button>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-red fix-btn"
            >
              <i className="dripicons-cross me-2 icon-center"></i>
              <span>Cancel</span>
            </button>
          </div>

          <Row className="mb-2">
            <Col>
              <select
                className="me-4 form-select"
                style={{ width: "100px" }}
                value={pageSize}
                onChange={e => setPageSize(e.target.value)}
              >
                {[10, 25, 50, 100].map(v => (
                  <option key={v} value={v}>
                    Show {v}
                  </option>
                ))}
              </select>
            </Col>
            <Col className="d-flex justify-content-end col-md-10">
              <div className="me-4">
                <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                  <div className="position-relative">
                    <label htmlFor="search-bar-0" className="search-label">
                      <span id="search-bar-0-label" className="sr-only">
                        Search this table
                      </span>
                      <input
                        onChange={e => setGlobalFilter(e.target.value)}
                        id="search-bar-0"
                        type="text"
                        className="form-control rounded h-100"
                        placeholder="Search..."
                        value={globalFilter || ""}
                      />
                    </label>
                    <i className="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div className="text-md-end">
                <button
                  type="button"
                  className="btn text-white me-2 btn-purple"
                  onClick={() => setRow(2)}
                >
                  <i className="fas fa-plus me-2 icon-size"></i>Generate
                  Document
                </button>
                <button onClick={() => navigate(-1)} className="btn btn-red">
                  <i className="dripicons-cross me-2 icon-center"></i>CANCEL
                </button>
              </div>
            </Col>
          </Row>

          <div className="row">
            <div className="col-md-4 d-flex justify-content-center pt-4">
              <div className={fixedContent ? "staffDocuments" : ""}>
                <img
                  src={staffDocuments}
                  alt="staffDocuments"
                  className="w-100"
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="position-relative">
                <Table
                  className="table table-bordered mt-4"
                  {...getTableProps()}
                >
                  <thead
                    className={`fix-genrateDoc-header ${
                      fixedContent ? "fix-header-genrateDoc" : ""
                    }`}
                  >
                    {headerGroups.map((hg, i) => (
                      <tr key={i} {...hg.getHeaderGroupProps()}>
                        {hg.headers.map((col, idx) => (
                          <th
                            key={idx}
                            className={`t-col-${idx + 1} ${col.className}`}
                            {...col.getHeaderProps()}
                          >
                            {col.render("Header")}
                            {col.isInfoIcon && (
                              <a
                                onClick={() => {
                                  setNameModal(true)
                                  setTitle(col.Header)
                                }}
                              >
                                <i
                                  title="info"
                                  className="bx bx-info-circle ms-1 info-icon"
                                ></i>
                              </a>
                            )}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((r, i) => {
                      prepareRow(r)
                      return (
                        <tr className="row-hover" key={i} {...r.getRowProps()}>
                          {r.cells.map((c, idx) => (
                            <td
                              key={idx}
                              className={`t-col-${idx + 1} ${
                                c.column.className
                              }`}
                              {...c.getCellProps()}
                            >
                              {c.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      )
                    })}
                    {page.length === 0 && (
                      <tr>
                        <td colSpan={10} className="text-center">
                          No Documents Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>

          <Row className="justify-content-md-end justify-content-center align-items-center">
            <NewPagination
              gotoPage={gotoPage}
              canPreviousPage={canPreviousPage}
              previousPage={previousPage}
              canNextPage={canNextPage}
              pageIndex={pageIndex}
              pageOptions={pageOptions}
              pageSize={pageSize}
              page={page}
              data={data}
              nextPage={nextPage}
            />
          </Row>

          {/* Info Modal */}
          <Modal
            isOpen={name_modal}
            toggle={() => setNameModal(false)}
            centered
            className="bd-info-popup"
          >
            <div className="modal-header bd-head-info">
              <h5 className="modal-title mt-0">
                <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
                {title}
              </h5>
            </div>
            <div className="modal-body pb-0">
              {info.map(
                (it, i) =>
                  it.title === title && (
                    <div key={i}>
                      <span
                        dangerouslySetInnerHTML={{ __html: it.mean }}
                      ></span>
                      <div
                        dangerouslySetInnerHTML={{ __html: it.purpose }}
                      ></div>
                    </div>
                  )
              )}
              <div className="text-center mt-70">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => setNameModal(false)}
                >
                  I Understood <i className="dripicons-thumbs-up pl-10"></i>
                </button>
              </div>
            </div>
          </Modal>
        </div>
      )}

      {/* ---------- CREATE FORM ---------- */}
      {row === 2 && (
        <div>
          <form onSubmit={handleSubmit}>
            <div
              className={`flex-column fixed-buttons pt-2 ${
                fixedContent ? "d-flex" : "d-none"
              }`}
            >
              <button
                type="submit"
                className="btn btn-save fix-btn btn-label pe-0"
              >
                <i className="fas fa-save me-2 label-icon"></i>
                <span>Save</span>
              </button>
              <button
                type="button"
                onClick={() => {
                  setRow(1)
                  setRequirementType(null)
                  setLetterTemplateValue(null)
                  setDescription("")
                }}
                className="btn btn-red fix-btn btn-label pe-0"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                <span>Cancel</span>
              </button>
            </div>

            <div className="h-100 bg-white px-4">
              <Row className="py-4 h-100 mb-3">
                <div className="row mb-3 align-items-start justify-content-between">
                  <div className="col-md-7">
                    <div className="row mb-3">
                      <div className="col-md-4 mb-3">
                        <label>
                          Document Type <span className="text-danger">*</span>
                        </label>
                        <Select
                          value={requirementType}
                          placeholder="Select Type"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={letterType}
                          onChange={e => {
                            setRequirementType(e)
                            setLetterTemplateValue(null)
                            fetchLetterTemplateOptions(e)
                          }}
                        />
                      </div>
                      <div className="col-md-5">
                        <label>
                          Document Template{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          value={letterTemplateValue}
                          placeholder="Select Template"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={letterTemplateOptions}
                          onChange={e => {
                            setLetterTemplateValue(e)
                            setDescription(e?.template || "")
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5 d-flex justify-content-end align-items-start">
                    <div className="btn-group">
                      <a
                        onClick={() => setmodal_large(true)}
                        className="btn btn-save me-2"
                      >
                        Dynamic Fields
                      </a>
                      <button
                        type="submit"
                        className="btn btn-save me-2 btn-label"
                      >
                        <i className="fas fa-save me-1 label-icon"></i> Save
                      </button>
                      <a
                        onClick={() => {
                          setRow(1)
                          setRequirementType(null)
                          setLetterTemplateValue(null)
                          setDescription("")
                        }}
                        className="btn btn-red btn-label"
                      >
                        <i className="dripicons-cross me-2 icon-center label-icon"></i>{" "}
                        Cancel
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 mt-4">
                  <Editor
                    key={row}
                    initialValue={description || ""}
                    apiKey="w6fz9u4rgsouz7jqcyy4lflpolp0tjwkx1bzoc70ntetxwys"
                    init={{
                      height: 800,
                      menubar: true,
                      plugins: [
                        "a11ychecker",
                        "accordion",
                        "advlist",
                        "advcode",
                        "advtable",
                        "autolink",
                        "checklist",
                        "export",
                        "lists",
                        "link",
                        "image",
                        "charmap",
                        "anchor",
                        "searchreplace",
                        "visualblocks",
                        "powerpaste",
                        "fullscreen",
                        "formatpainter",
                        "insertdatetime",
                        "media",
                        "table",
                        "wordcount",
                        "code",
                        "pagebreak",
                        "quickbars",
                        "codesample",
                        "textcolor",
                      ],
                      toolbar:
                        "undo redo | casechange blocks | bold italic backcolor | fontselect fontsizeselect |" +
                        "alignleft aligncenter alignright alignjustify | bullist numlist checklist outdent indent | " +
                        "removeformat | a11ycheck code table | exportpdf |",
                      fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
                    }}
                    onEditorChange={handleEditorChange}
                  />
                </div>
              </Row>
            </div>
          </form>
        </div>
      )}

      {/* ---------- EDIT FORM ---------- */}
      {row === 3 && (
        <div>
          <form onSubmit={handleEditDoc}>
            <div
              className={`flex-column fixed-buttons pt-2 ${
                fixedContent ? "d-flex" : "d-none"
              }`}
            >
              <button
                type="submit"
                className="btn btn-save fix-btn btn-label pe-0"
              >
                <i className="fas fa-save me-2 label-icon"></i>
                <span>Update</span>
              </button>
              <button
                type="button"
                onClick={() => setRow(1)}
                className="btn btn-red fix-btn btn-label pe-0"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                <span>Cancel</span>
              </button>
            </div>

            <div className="h-100 bg-white px-4">
              <Row className="py-4 h-100 mb-3">
                <div className="row mb-3 align-items-start justify-content-between">
                  <div className="col-md-7">
                    <div className="row mb-3">
                      <div className="col-md-4 mb-3">
                        <label>
                          Document Type <span className="text-danger">*</span>
                        </label>
                        <Select
                          value={requirementType}
                          placeholder="Select Type"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={letterType}
                          onChange={async e => {
                            setRequirementType(e)
                            setLetterTemplateValue(null)
                            await fetchLetterTemplateOptions(e)
                          }}
                        />
                      </div>
                      <div className="col-md-5">
                        <label>
                          Document Template{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          value={letterTemplateValue}
                          placeholder="Select Template"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={letterTemplateOptions}
                          onChange={e => {
                            setLetterTemplateValue(e)
                            setDescription(e?.template || "")
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5 d-flex justify-content-end align-items-start">
                    <div className="btn-group">
                      <a
                        onClick={() => setmodal_large(true)}
                        className="btn btn-save me-2"
                      >
                        Dynamic Fields
                      </a>
                      <button
                        type="submit"
                        className="btn btn-save me-2 btn-label"
                      >
                        <i className="fas fa-save me-1 label-icon"></i> Update
                      </button>
                      <a
                        onClick={() => setRow(1)}
                        className="btn btn-red btn-label"
                      >
                        <i className="dripicons-cross me-2 icon-center label-icon"></i>{" "}
                        Cancel
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 mt-4">
                  <Editor
                    key={row}
                    initialValue={editorContent}
                    apiKey="w6fz9u4rgsouz7jqcyy4lflpolp0tjwkx1bzoc70ntetxwys"
                    init={{
                      height: 800,
                      menubar: true,
                      plugins: [
                        "a11ychecker",
                        "accordion",
                        "advlist",
                        "advcode",
                        "advtable",
                        "autolink",
                        "checklist",
                        "export",
                        "lists",
                        "link",
                        "image",
                        "charmap",
                        "anchor",
                        "searchreplace",
                        "visualblocks",
                        "powerpaste",
                        "fullscreen",
                        "formatpainter",
                        "insertdatetime",
                        "media",
                        "table",
                        "wordcount",
                        "code",
                        "pagebreak",
                        "quickbars",
                        "codesample",
                        "textcolor",
                      ],
                      toolbar:
                        "undo redo | casechange blocks | bold italic backcolor | fontselect fontsizeselect |" +
                        "alignleft aligncenter alignright alignjustify | bullist numlist checklist outdent indent | " +
                        "removeformat | a11ycheck code table | exportpdf |",
                      fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
                    }}
                    onEditorChange={handleEditorChange}
                  />
                </div>
              </Row>
            </div>
          </form>
        </div>
      )}

      {/* ---------- DYNAMIC FIELDS MODAL ---------- */}
      {/* <Modal size="xl" isOpen={modal_large} centered style={{ zIndex: 99999999999999999 }}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Dynamic Fields</h5>
          <button type="button" onClick={() => setmodal_large(false)} className="btn-modal-close">
            <span className="btn-modal-span">x</span>
          </button>
        </div>
        <div className="modal-body">
          <Row>
            <div className="d-flex flex-wrap position-relative">
              {[
                { label: "Employee Name", value: "$emp_name" },
                { label: "Joining Date", value: "$join_date" },
                { label: "Employee Id", value: "$emp_id" },
                { label: "Designation", value: "$designation" },
                { label: "Basic Salary", value: "$basic_salary" },
                { label: "Dearness Allowance", value: "$dearness_allowance" },
                { label: "House Rent Allowance", value: "$house_rent" },
                { label: "Conveyance", value: "$conveyance" },
                { label: "Address line 1", value: "$address_1" },
                { label: "Address line 2", value: "$address_2" },
                { label: "City", value: "$city" },
                { label: "State", value: "$state" },
                { label: "Country", value: "$country" },
                { label: "Pincode", value: "$pincode" },
              ].map((f, i) => (
                <div key={i} className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                  <label className="col-4 mb-0">{f.label}</label>
                  <div className="p-2 me-3 col-5 bg-dynamic-field">{f.value}</div>
                  <CopyToClipboard text={f.value} onCopy={() => Swal.fire({ icon: "success", title: "Copied!", timer: 1000, showConfirmButton: false })}>
                    <button className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"></button>
                  </CopyToClipboard>
                </div>
              ))}
            </div>
          </Row>
        </div>
      </Modal> */}
      {modal_large ? (
        <Draggable
          handle=".drag-header" // drag only by header
          bounds="body" // prevent moving off-screen
        >
          <div
            style={{
              position: "fixed",
              top: "10%", // <<< SET YOUR OWN POSITION HERE
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 999999,
            }}
          >
            {/* RESIZABLE WRAPPER */}
            <ResizableBox
              width={1000}
              height={443}
              minConstraints={[650, 350]}
              maxConstraints={[1500, 900]}
              resizeHandles={["se"]}
            >
              {/* MAIN MODAL CONTENT */}
              <div
                className="modal-content"
                style={{
                  height: "100%",
                  // overflow: "auto",
                  zIndex: 999999,
                }}
              >
                {/* HEADER (DRAG HANDLE) */}
                <div
                  className="modal-header drag-header"
                  // style={{
                  //   cursor: "move",
                  //   userSelect: "none",
                  // }}
                >
                  <h5 className="modal-title mt-0 mb-3">Dynamic Fields</h5>

                  <button
                    type="button"
                    onClick={() => setmodal_large(false)}
                    className="btn-modal-close"
                  >
                    <span aria-hidden="true" className="btn-modal-span">
                      ×
                    </span>
                  </button>
                </div>

                {/* BODY */}
                <div className="modal-body">
                  <Row>
                    <div className="d-flex flex-wrap position-relative">
                      {/* ---------------------------- */}
                      {/* FULL DYNAMIC FIELDS LIST     */}
                      {/* ---------------------------- */}

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2 ">
                        <label htmlFor="" className="col-4 mb-0">
                          Employee Name
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$emp_name"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(0)}
                          value="$emp_name"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Joining Date
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$join_date"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(1)}
                          value="$join_date"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Employee Id
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$emp_id"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(2)}
                          value="$emp_id"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Designation
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$designation"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(3)}
                          value="$designation"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Basic Salary
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$basic_salary"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(4)}
                          value="$basic_salary"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Dearness Allowance
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$dearness_allowance"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(5)}
                          value="$dearness_allowance"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          House Rent Allowance
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$house_rent"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(6)}
                          value="$house_rent"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Conveyance
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$conveyance"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(7)}
                          value="$conveyance"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Address line 1
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$address_1"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(8)}
                          value="$address_1"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Address line 2
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$address_2"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(9)}
                          value="$address_2"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          City
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$city"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(10)}
                          value="$city"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          State
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$state"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(11)}
                          value="$state"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Country
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$country"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(12)}
                          value="$country"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Pincode
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$pincode"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(13)}
                          value="$pincode"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="copy-modal-line"></div>
                    </div>
                  </Row>
                </div>
              </div>
            </ResizableBox>
          </div>
        </Draggable>
      ) : null}
    </div>
  )
}

/* ------------------------------------------------------------------ */
/* ---------------------------  MAIN COMPONENT  --------------------- */
/* ------------------------------------------------------------------ */
const GenerateDocument = ({
  verticalActiveTab,
  setverticalActiveTab,
  staffId,
}) => {
  const [row, setRow] = useState(1)
  const [editDocID, setEditDocID] = useState("")
  const [data, setDatas] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [requirementType, setRequirementType] = useState(null)
  const [description, setDescription] = useState("")
  const [letterTemplateValue, setLetterTemplateValue] = useState(null)
  const [letterType, setLetterTypeOptions] = useState([])
  const [letterTemplateOptions, setLetterTemplateOptions] = useState([])

  const staffIdp = staffId || localStorage.getItem("staffId")

  /* ---------- edit existing letter ---------- */
  const editDoc = async id => {
    const token = secureLocalStorage.getItem("auth_token")
    try {
      const res = await axios({
        method: "get",
        url: `${configure.nodeApi}/showStaffLetter/${id}`,
        headers: { Authorization: "Bearer " + token },
      })
      if (res?.data?.success) {
        const d = res.data.data
        setDescription(d.new_template)
        setEditDocID(id)
        setRow(3)

        // load types
        const typesRes = await fetchNodeData(setLoading, `LetterTypes`, token)
        if (typesRes?.status) {
          const types = typesRes.data.map(x => ({
            value: x.id,
            label: x.LetterName,
          }))
          setLetterTypeOptions(types)

          const matchedType = types.find(t => t.label === d.requirement_type)
          if (matchedType) {
            setRequirementType(matchedType)

            // load templates for that type
            const tmplRes = await fetchNodeData(
              setLoading,
              `staffTemplate/Options/${matchedType.value}`,
              token
            )
            if (tmplRes?.data) {
              const tmpls = tmplRes.data.map(x => ({
                value: x.id,
                label: x.name,
                template: x.description,
              }))
              setLetterTemplateOptions(tmpls)

              const matchedTmpl = tmpls.find(t => t.label === d.LetterTemplate)
              setLetterTemplateValue(
                matchedTmpl || { label: d.LetterTemplate, value: null }
              )
              setDescription(matchedTmpl?.template || d.new_template)
            }
          }
        }
      }
    } catch (e) {
      console.error(e)
    }
  }

  /* ---------- table columns ---------- */
  const columns = useMemo(
    () => [
      { Header: "ID", accessor: "id", className: "text-center" },
      {
        Header: "Document Type",
        accessor: "requirement_type",
        isInfoIcon: true,
      },
      { Header: "Template Type", accessor: "letterTemplate" },
      {
        Header: "Signature",
        accessor: "signature",
        className: "text-center",
        Cell: c => (
          <Badge
            className={c.row.original.signature ? "bg-success" : "bg-danger"}
          >
            {c.row.original.signature ? "Signed" : "Not signed"}
          </Badge>
        ),
      },
      {
        Header: "Created",
        accessor: "created_at",
        className: "text-center",
        Cell: c =>
          c.row.original.created_at
            ? moment(c.row.original.created_at).format("DD-MM-YYYY")
            : "-",
      },
      {
        Header: "Action",
        accessor: "action",
        className: "text-center t-col-1",
        Cell: cell => {
          const [copied, setCopied] = useState(false)
          const deleteDoc = id => {
            Swal.fire({
              icon: "warning",
              title: "Delete?",
              text: "This action cannot be undone.",
              showCancelButton: true,
            }).then(async ok => {
              if (ok.isConfirmed) {
                setLoading(true)
                const fd = new FormData()
                fd.append("staff_id", staffIdp)
                fd.append("letter_id", id)
                await axios.post(`${configure.apiUrl}/deleteLetter`, fd, {
                  headers: { "Content-Type": "multipart/form-data" },
                })
                fetchData()
                setLoading(false)
              }
            })
          }

          return (
            <div className="d-flex justify-content-center">
              {cell.row.original.approve == 1 && (
                <a
                  href={`${configure.appUrl}viewapprovedoc/${cell.row.original.id}`}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-sm btn-outline-secondary me-1"
                >
                  <i className="fa fa-eye"></i>
                </a>
              )}
              <UncontrolledDropdown>
                <DropdownToggle
                  className="btn btn-sm btn-outline-secondary w-100"
                  color="white"
                >
                  <i className="mdi mdi-dots-horizontal"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  {cell.row.original.approve == 1 && (
                    <CopyToClipboard
                      text={`https://edemo.zithas.com${configure.appUrl}staff/letters/${cell.row.original.junk_id}`}
                      onCopy={() => {
                        setCopied(true)
                        setTimeout(() => setCopied(false), 1000)
                      }}
                    >
                      <button className="dropdown-item copyBtn">
                        <i className="fas fa-copy pr-10"></i>
                        {copied ? "Copied!" : "Copy Link"}
                      </button>
                    </CopyToClipboard>
                  )}
                  <a
                    onClick={() => editDoc(cell.row.original.id)}
                    className="dropdown-item"
                  >
                    <i className="fas fa-pencil-alt text-secondary pr-10"></i>{" "}
                    Edit Document
                  </a>
                  <a
                    onClick={() => deleteDoc(cell.row.original.id)}
                    className="dropdown-item"
                  >
                    <i className="fas fa-trash-alt text-danger pr-10"></i>{" "}
                    Delete Document
                  </a>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ],
    []
  )

  const fetchData = async () => {
    const token = secureLocalStorage.getItem("auth_token")
    const res = await axios.get(
      `${configure.apiUrl}/staffLetters/${staffIdp}`,
      {
        headers: { Authorization: "Bearer " + token },
      }
    )
    setDatas(res?.data?.data || [])
  }

  useEffect(() => {
    if (verticalActiveTab === "9" && staffIdp) fetchData()
  }, [verticalActiveTab, staffIdp])

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <Container fluid>
        <Row>
          <Col lg={12} className="p-0">
            <Card>
              <CardBody>
                <div className="responsive-table">
                  <TableContainer
                    columns={columns}
                    data={data}
                    setLoading={setLoading}
                    setDatas={setDatas}
                    row={row}
                    setRow={setRow}
                    editDocID={editDocID}
                    editDoc={editDoc}
                    requirementType={requirementType}
                    setRequirementType={setRequirementType}
                    description={description}
                    setDescription={setDescription}
                    staffIdp={staffIdp}
                    fetchData={fetchData}
                    setLetterTemplateValue={setLetterTemplateValue}
                    letterTemplateValue={letterTemplateValue}
                    setLetterTypeOptions={setLetterTypeOptions}
                    letterType={letterType}
                    setLetterTemplateOptions={setLetterTemplateOptions}
                    letterTemplateOptions={letterTemplateOptions}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}

export default GenerateDocument
